import { render, staticRenderFns } from "./ResourceUpload.vue?vue&type=template&id=269341c6&scoped=true"
import script from "./ResourceUpload.vue?vue&type=script&lang=js"
export * from "./ResourceUpload.vue?vue&type=script&lang=js"
import style0 from "./ResourceUpload.vue?vue&type=style&index=0&id=269341c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269341c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269341c6')) {
      api.createRecord('269341c6', component.options)
    } else {
      api.reload('269341c6', component.options)
    }
    module.hot.accept("./ResourceUpload.vue?vue&type=template&id=269341c6&scoped=true", function () {
      api.rerender('269341c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/ResourceUpload.vue"
export default component.exports